import {
  formatDay,
  formatHour,
  formatTwoDigitDay,
  formatTwoDigitYear,
  formatWithoutDay,
} from "../../lib/time";

type Props = {
  start_date: string | any;
  title: string;
  end_date: string | any;
  organized_by?: string;
  hosted_by?: string;
  venue?: string;
  campaign_Address?: string;
};

export default function DateCard({
  start_date,
  end_date,
  title,
  hosted_by,
  organized_by,
  venue,
  campaign_Address,
}: Props) {
  return (
    <>
      <div className="w-[85px] flex-col justify-center items-start gap-[7px] inline-flex">
        <div className="self-stretch h-[74px] text-[#212529] text-[64px] font-bold ">
          {formatTwoDigitDay(start_date)}
        </div>
        <div className="self-stretch text-[#212529] text-base font-semibold  uppercase leading-normal">
          {formatWithoutDay(start_date)}
        </div>
      </div>

      <div className="w-0.5 self-stretch bg-[#adb5bd]" />

      <div className="grow shrink basis-0 flex-col justify-start items-start gap-2.5 inline-flex">
        <div className="self-stretch h-[142px] flex-col justify-start items-start gap-1.5 flex">
          <div className="self-stretch text-[#212529] text-4xl font-normal font-['Tiro Bangla'] leading-[48px]">
            {title}
          </div>

          <div className="self-stretch h-[88px] flex-col justify-center items-start gap-1 flex">
            <div className="px-1.5 py-1 bg-[#f28e72] justify-start items-center gap-1.5 inline-flex">
              <div className="text-white text-base font-semibold  leading-normal">
                {formatDay(start_date)}, {formatHour(start_date)} -{" "}
                {formatHour(end_date)}
              </div>
            </div>

            <div className="justify-start items-center gap-1.5 inline-flex text-nowrap">
              <div className="justify-start items-center gap-1.5 flex ">
                <div className="text-[#f28e72] text-base font-semibold  leading-normal text-nowrap">
                  Organized by:
                </div>
                <div className="text-[#212529] text-base font-semibold leading-normal text-nowrap">
                  {organized_by || "name"}
                </div>
              </div>

              <div className="justify-start items-center gap-2 flex">
                <div className="text-[#6c757d] text-base font-semibold  leading-normal">
                  |
                </div>
              </div>

              <div className="justify-start items-center gap-1.5 flex text-nowrap">
                <div className="text-[#f28e72] text-base font-semibold  leading-normal text-nowrap">
                  Hosted by:
                </div>
                <div className="text-[#212529] text-base font-semibold  leading-normal text-nowrap">
                  {hosted_by || "name"}
                </div>
              </div>
            </div>

            <div className="justify-start items-center gap-1.5 inline-flex">
              <div className="text-[#f28e72] text-base font-semibold  leading-normal">
                Venue:
              </div>
              <div className="text-[#212529] text-base font-normal font-['Tiro Bangla'] leading-normal">
                {campaign_Address || "venue name"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
